import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/loading_bg.png';

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	transition: opacity 0.3s ease;
	&.loading-enter {
		opacity: 0;
	}

	&.loading-enter-active,
	&.loading-enter-done,
	&.loading-exit {
		opacity: 1;
	}

	&.loading-exit-active {
		opacity: 0;
	}
`;

const StyledCenterContainer = styled.div`
	position: absolute;
	top: calc(50% + 10px);
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 37px;

	img {
		width: 60px;
		height: 60px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 700;
		font-size: 20px;
		text-align: center;
		color: #ffffff;
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	top: -650px;
	left: 50%;
	transform: translateX(-50%);
	width: 1300px;
	height: 1300px;
	mask-image: url(${shadow});
	mask-size: 1300px 1300px;
	mask-repeat: no-repeat;
	mask-position: center;
`;

const StyledLoadingText = styled(Text)`
	position: absolute;
	bottom: 28px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 14px;
	color: #ffffff;
	opacity: 0.25;
`;

export {
	StyledCenterContainer,
	StyledContainer,
	StyledLoadingText,
	StyledShadow,
};
